import { Nav } from 'react-bootstrap';
import { FormattedMessage } from 'react-intl';

function EventsTableNav({ activeTab, navItems, handleActiveTabChange }) {
  return (
    <Nav variant="tabs" defaultActiveKey={activeTab}>
      {navItems.map((item) => (
        <Nav.Item key={item.link} onClick={() => handleActiveTabChange(item.link)}>
          <Nav.Link
            eventKey={item.link}
            className={`h-100  ${item.link === activeTab ? 'text-primary' : ''}`}>
            <div className="font-weight-bold m-0">
              {item.dontTranslate ? item.title : <FormattedMessage id={item.title} />}
            </div>
          </Nav.Link>
        </Nav.Item>
      ))}
    </Nav>
  );
}

export default EventsTableNav;
